import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getSchedule = deliveryZoneId =>
  privateAxios({
    method: 'get',
    baseURL: adminAPI,
    url: `/schedule/${deliveryZoneId}`,
  });
